export default __webpack_public_path__ + "static/companyLogo-e50ba543a760c2d211de9eb7b196953f.svg";